import { useState, ReactNode, useEffect } from "react";
import SpinnerLoader from "../loader/spinner-loader";
import { createPortal } from 'react-dom';

type DefaultModalType = {
    icon?: any,
    description?: string,
    modalButtonTriggerText?: ReactNode,
    modalButtonConfirmationText?: string,
    modalButtonCancelText?: string,
    onConfirmationAction?: () => void,
}

const DefaultModal = ({
    icon,
    description = 'What do you want to do?',
    modalButtonTriggerText = 'Open Modal',
    modalButtonConfirmationText = 'Yes',
    modalButtonCancelText = 'No',
    onConfirmationAction,
}: DefaultModalType) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const processAction = async () => {
        setLoading(true);
        onConfirmationAction && await onConfirmationAction();
        setShowModal(false);
        setLoading(false);
    }

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        }
    }, [showModal]);

    return (
        <div className="relative">
            <span onClick={() => setShowModal(true)} className="cursor-pointer">
                {modalButtonTriggerText ?? 'open modal'}
            </span>
            {showModal && createPortal(
                <div>
                    <div className={`${showModal ? 'flex' : 'hidden'} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[100] justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}>
                        <div className="relative w-full max-w-md max-h-full p-4">
                            <div className="relative bg-white rounded-lg shadow">
                                <div className="p-4 text-center md:p-5">
                                    <div className="flex justify-center w-full">
                                        {icon}
                                    </div>
                                    <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                                        {description}
                                    </h3>
                                    <button onClick={processAction} type="button" className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                                        <span>{modalButtonConfirmationText} </span>
                                        {loading && <SpinnerLoader />}
                                    </button>
                                    <button onClick={() => setShowModal(!showModal)} type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 ">
                                        {modalButtonCancelText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`fixed inset-0 z-50 bg-gray-900/50 ${showModal ? '' : 'hidden'}`}></div>
                </div>
                , document.body)}
        </div>
    );
}

export default DefaultModal